module.exports = __webpack_public_path__ + "static/media/PW.fa90bcdf.png";